/**
 * Компонент Swiper слайдера для навигации по категориям.
 */
import Swiper from 'swiper';

class CategoriesNav {
    /**
     * Инициализирует слайдер, если блок есть на странице.
     */
    constructor() {
        const swiperEl = document.querySelector('.categories-nav__swiper');

        if (!swiperEl) {
            return;
        }

        return new Swiper(swiperEl, this.getDefaultConfig());
    }

    /**
     * @returns {Object}
     */
    getDefaultConfig() {
        return {
            slidesPerView: 'auto',
            spaceBetween: 8,
        };
    }
}

export default CategoriesNav;
